import React, { useEffect, useState } from "react";
import reportHealthService from "../../../../../../../../../Service/OPSServices/StoreHealthServices/reportHealthService.js";

const fmt = (v) => new Intl.NumberFormat("en-US").format(v || 0);
export const size = (b) =>
  b >= 1048576
    ? `${(b / 1048576).toFixed(1)} MB`
    : b >= 1024
    ? `${Math.round(b / 1024)} KB`
    : `${b} B`;
const cell = (v) =>
  v === null || v === undefined
    ? ""
    : typeof v === "number"
    ? v.toLocaleString("en-US", { maximumFractionDigits: 4 })
    : String(v);

/** The saved report from the payload table: first rows as a table (or the text), plus a full download. */
export default function PayloadView({ payloadId, filename }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    let live = true;
    setData(null);
    setError(null);
    reportHealthService
      .getPayload(payloadId)
      .then((d) => live && setData(d))
      .catch((e) => live && setError(e.message));
    return () => {
      live = false;
    };
  }, [payloadId]);

  const download = async () => {
    setDownloading(true);
    try {
      await reportHealthService.downloadPayload(payloadId, filename);
    } catch (e) {
      setError(`Download failed: ${e.message}`);
    } finally {
      setDownloading(false);
    }
  };

  if (error) return <div className="ams-banner ams-banner--err">Could not load the payload: {error}</div>;
  if (!data) return <div className="ams-hint">Loading the saved data…</div>;

  return (
    <div className="rh-payload">
      <div className="rh-payload-head">
        <span>
          {data.totalRows != null ? (
            <>
              <strong>{fmt(data.totalRows)}</strong> {data.totalRows === 1 ? "row" : "rows"}
              {data.totalRows > data.rows.length
                ? `, showing the first ${fmt(data.rows.length)}`
                : ""}
            </>
          ) : (
            "Saved data (not a table)"
          )}
          <span className="ams-dash">
            {" "}
            · {size(data.bytes)}
            {data.columns.length ? ` · ${data.columns.length} columns` : ""}
          </span>
        </span>
        <button
          type="button"
          className="ams-btn rh-small-btn"
          onClick={download}
          disabled={downloading}
        >
          {downloading ? "Downloading…" : "Download JSON"}
        </button>
      </div>
      {data.totalRows === 0 && (
        <p className="ams-hint">
          The report was saved with no rows: Amazon had no data for this day.
        </p>
      )}
      {data.rows.length > 0 && (
        <div className="rh-payload-table">
          <table className="ams-table">
            <thead>
              <tr>
                {data.columns.map((c) => (
                  <th key={c}>{c}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.rows.map((r, i) => (
                <tr key={i}>
                  {r.map((v, j) => (
                    <td key={j} className={typeof v === "number" ? "ams-num" : ""}>
                      {cell(v)}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {data.text != null && (
        <pre className="rh-log">
          {data.text}
          {data.bytes > data.text.length ? "\n…" : ""}
        </pre>
      )}
    </div>
  );
}
